import qs from 'qs'
import { ThisConnector } from '../../../../../../api/connector'
import { SelectedValueReportingFacet } from '../../../../../../graphql/schema/types/value-reporting'

export interface VrOpenClosedVulnsArgs {
  organizationUuid: string
  facets: SelectedValueReportingFacet[]
  since?: number
  until?: number
  resolution?: string
}

export interface VrOpenClosedVulnsResponse {
  series: TimeSeries[]
  lastSeenDate: number
}

interface TimeSeries {
  id: string
  name: string
  fields: string[]
  values: number[][]
}

export async function getVrOpenClosedVulns(
  this: ThisConnector,
  { organizationUuid, facets, since, until, resolution }: VrOpenClosedVulnsArgs
) {
  const params = qs.stringify(
    { since, until, resolution },
    { addQueryPrefix: true }
  )

  return this.connector.post(
    `/organizations/${organizationUuid}/application-security-summary/vulnerabilities/trends${params}`,
    { facets }
  )
}
